import { Component } from "@angular/core";
import Highcharts from "highcharts/highmaps";
import { Options } from "highcharts";
import worldMap from "@highcharts/map-collection/custom/world.geo.json";

@Component({
  selector: 'app-map-chart',
  templateUrl: './map-chart.component.html',
  styleUrls: ['./map-chart.component.scss']
})
export class MapChartComponent {

  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor = "mapChart";
  chartData = [{ code3: "ABW", z: 105 }, { code3: "AFG", z: 35530 }];

  chartOptions: Options = {
    chart: {
      map: worldMap as any,
      backgroundColor: 'transparent'
    },
    title: {
      text: 'Assets Under Management',
      style: {color: 'grey'}
    },
    mapNavigation: {
      enabled: true,
      buttonOptions: {
        alignTo: "spacingBox"
      }
    },
    legend: {
      title: {
        text: 'AUM in billion $',
        style: {color: 'grey'}
      },
      enabled: true,
      itemStyle: {
        color: 'grey'
      }
    },
    colorAxis: {
      dataClasses: [{
          to: 0.1,
          name: '< 0.1'
      }, {
          from: 0.1,
          to: 1,
          name: '0.1 - 1.0'
      }, {
          from: 1,
          to: 10,
          name: '1.0 - 10'
      }, {
          from: 10,
          to: 100,
          name: '10 - 100'
      }, {
        from: 100,
        to: 500,
        name: '100 - 500'
      }, {
        from: 500,
        name: '> 500'
      }],
      labels: {
        formatter: function() {return this.value.toFixed(1)}
      }
    },
    tooltip: {
      style: {color: 'grey'},
      backgroundColor: 'none',
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      padding: 0,
      pointFormatter: function() {
        if (this.value > 0) {
          return `<span><span class="f32"><span class="flag ${this.properties['hc-key']}" style="vertical-align: middle !important;">` +
                 `</span></span> ${this.name}<br>` +
                 `<span style="font-size:30px">${this.value} billion $</span></span>`;
        } else {
          return `<span><span class="f32"><span class="flag ${this.properties['hc-key']}" style="vertical-align: middle !important;">` +
                 `</span></span> ${this.name}<br>` +
                 `<span style="font-size:30px"> — </span></span>`;
        }
      },
      positioner: function () {
        return { x: 0, y: 250 };
      }
    },
    series: [
      {
        type: "map",
        name: "AUM",
        states: {
          hover: {
            color: "#a4edba"
          }
        },
        dataLabels: {
          enabled: false,
          format: "{point.name}"
        },
        allAreas: false,
        data: [
          ["fo", 0.002689],
          ["um", 0],
          ["us", 544.54],
          ["jp", 0],
          ["sc", 0],
          ["in", 0],
          ["fr", 123.78],
          ["fm", 0],
          ["cn", 13.61],
          ["pt", 0],
          ["sw", 0],
          ["sh", 0],
          ["br", 1.87],
          ["ki", 0],
          ["ph", 0],
          ["mx", 0],
          ["es", 1.42],
          ["bu", 0],
          ["mv", 0],
          ["sp", 0],
          ["gb", 157.6],
          ["gr", 0],
          ["as", 0],
          ["dk", 0],
          ["gl", 2.71],
          ["gu", 0],
          ["mp", 0],
          ["pr", 0],
          ["vi", 0],
          ["ca", 71.71],
          ["st", 0],
          ["cv", 0],
          ["dm", 0],
          ["nl", 0],
          ["jm", 0],
          ["ws", 0],
          ["om", 0],
          ["vc", 0],
          ["tr", 0],
          ["bd", 0],
          ["lc", 0],
          ["nr", 0],
          ["no", 0],
          ["kn", 0],
          ["bh", 0],
          ["to", 0],
          ["fi", 0],
          ["id", 0],
          ["mu", 0],
          ["se", 0],
          ["tt", 0],
          ["my", 0],
          ["pa", 0],
          ["pw", 0],
          ["tv", 0],
          ["mh", 0],
          ["cl", 0],
          ["th", 0],
          ["gd", 0],
          ["ee", 0],
          ["ag", 0],
          ["tw", 0],
          ["bb", 0],
          ["it", 15.88],
          ["mt", 0],
          ["vu", 0],
          ["sg", 0],
          ["cy", 0],
          ["lk", 0],
          ["km", 0],
          ["fj", 0],
          ["ru", 126.58],
          ["va", 0],
          ["sm", 0],
          ["kz", 0],
          ["az", 0],
          ["tj", 0],
          ["ls", 0],
          ["uz", 0],
          ["ma", 0],
          ["co", 0],
          ["tl", 0],
          ["tz", 0],
          ["ar", 0],
          ["sa", 16.43],
          ["pk", 0],
          ["ye", 0],
          ["ae", 0],
          ["ke", 0],
          ["pe", 0],
          ["do", 0],
          ["ht", 0],
          ["pg", 0],
          ["ao", 0],
          ["kh", 0],
          ["vn", 0],
          ["mz", 0],
          ["cr", 0],
          ["bj", 0],
          ["ng", 4.45],
          ["ir", 0],
          ["sv", 0],
          ["sl", 0],
          ["gw", 0],
          ["hr", 0],
          ["bz", 0],
          ["za", 0.86],
          ["cf", 0],
          ["sd", 0],
          ["cd", 0],
          ["kw", 0],
          ["de", 132.12],
          ["be", 0],
          ["ie", 0],
          ["kp", 0],
          ["kr", 0],
          ["gy", 0],
          ["hn", 0],
          ["mm", 0],
          ["ga", 0],
          ["gq", 0],
          ["ni", 0],
          ["lv", 0],
          ["ug", 0],
          ["mw", 0],
          ["am", 0],
          ["sx", 0],
          ["tm", 0],
          ["zm", 0],
          ["nc", 0],
          ["mr", 0],
          ["dz", 118.08],
          ["lt", 0],
          ["et", 0],
          ["er", 0],
          ["gh", 0],
          ["si", 0],
          ["gt", 0],
          ["ba", 0],
          ["jo", 0],
          ["sy", 0],
          ["mc", 0],
          ["al", 0],
          ["uy", 0],
          ["cnm", 0],
          ["mn", 0],
          ["rw", 0],
          ["so", 0],
          ["bo", 0],
          ["cm", 0],
          ["cg", 0],
          ["eh", 0],
          ["rs", 0],
          ["me", 0],
          ["tg", 0],
          ["la", 0],
          ["af", 0],
          ["ua", 0],
          ["sk", 0],
          ["jk", 0],
          ["bg", 0],
          ["qa", 0],
          ["li", 0],
          ["at", 0],
          ["sz", 0],
          ["hu", 0],
          ["ro", 0],
          ["ne", 0],
          ["lu", 0],
          ["ad", 0],
          ["ci", 0],
          ["lr", 0],
          ["bn", 0],
          ["iq", 0],
          ["ge", 0],
          ["gm", 0],
          ["ch", 102.7],
          ["td", 0],
          ["kv", 0],
          ["lb", 0],
          ["dj", 0],
          ["bi", 0],
          ["sr", 0],
          ["il", 0],
          ["ml", 0],
          ["sn", 0],
          ["gn", 0],
          ["zw", 0],
          ["pl", 0],
          ["mk", 0],
          ["py", 0],
          ["by", 0],
          ["cz", 0],
          ["bf", 0],
          ["na", 0],
          ["ly", 0],
          ["tn", 0],
          ["bt", 0],
          ["md", 0],
          ["ss", 0],
          ["bw", 0],
          ["bs", 0],
          ["nz", 0],
          ["cu", 0],
          ["ec", 0],
          ["au", 1.45],
          ["ve", 0],
          ["sb", 0],
          ["mg", 0],
          ["is", 0],
          ["eg", 0],
          ["kg", 0],
          ["np", 0]
        ]
      }
    ],
    credits: {
      enabled: false
    },
  };

}
